// extracted by mini-css-extract-plugin
export default {"checkbox":"BarcodeMismatchCheckbox_checkbox__Hp8bU"};